import { useCallback, useMemo, useState } from 'react';

import { canCollapseSummary, summaryState } from '../utils/summaryState.js';

/**
 * The row of Concierge cards under the profile header as ONE thing (CT-5713,
 * CT-5714): the Next Best Action and How to approach share a state (one
 * skeleton, one error row, one empty line), one Collapse that folds both, and
 * one Retry that re-requests both.
 *
 * @param {object} sources
 * @param {{ loading: boolean, error: unknown, items: object[], refetch: () => void }} sources.nba
 *   — `useProfileNextBestActions()`.
 * @param {{ loading: boolean, error: unknown, approach: object|null, refetch: () => void }} sources.approach
 *   — `useProfileHowToApproach()`.
 */
export function useProfileSummary({ nba, approach }) {
  const state = summaryState({ nba, approach });

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = useCallback(() => setCollapsed((value) => !value), []);

  const { refetch: refetchNba } = nba;
  const { refetch: refetchApproach } = approach;
  const retry = useCallback(() => {
    refetchNba();
    refetchApproach();
  }, [refetchNba, refetchApproach]);

  return useMemo(
    () => ({ state, canCollapse: canCollapseSummary(state), collapsed, toggleCollapsed, retry }),
    [state, collapsed, toggleCollapsed, retry],
  );
}

export default useProfileSummary;
